import { accessTokenService } from "@/services/access-token-service";
import {
    REFRESH_ACCESS_TOKEN
} from "@/store/action-types";
import {
    SET_ACCESS_TOKEN,
    SET_ACCESS_TOKEN_PROMISE
} from "@/store/mutation-types";

export const actions = {
    [REFRESH_ACCESS_TOKEN] ({ commit, state }, callback?) {
        let promise = state.accessTokenPromise;

        // If there is no existing promise, we create a new one for a new access token and add our callback to that chain.
        if (!promise) {
            promise = accessTokenService.create().then((token) => {
                commit(SET_ACCESS_TOKEN, token);
                return token;
            });
        }

        // Add the callback to the chain.
        if (callback) {
            promise = promise.then(callback);
        }

        commit(SET_ACCESS_TOKEN_PROMISE, promise);
        return promise;
    }
};

export type Actions = typeof actions;
